import { useGetPatientQuery } from '@/patient-app-common/api/patientApi';

import { FutureList } from './FutureList';
import { TodoList } from './TodoList';
import { TodoListReadOnly } from './TodoListReadOnly';

export function TodoIndex() {
  const { data: patient } = useGetPatientQuery();

  if (patient?.showOnGettingToSurgery) {
    return (
      <div className="w-full lg:w-[600px] mx-auto min-h-[100dvh] pt-8 pb-24">
        <TodoListReadOnly />
        <FutureList />
      </div>
    );
  }

  return (
    <div className="w-full lg:w-[600px] mx-auto min-h-[100dvh] pt-8 pb-24">
      <TodoList />
      <FutureList />
    </div>
  );
}
